import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  quotaTextField: {
    height: '100%',
    borderRadius: 0,
    background: '#ffffff',
    textAlign: 'center',
  },
  quotaInputTextField: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    fontWeight: 600,
    color: '#16141d',
  },
}));

export const SelectQuota = (
  { productId, initQuota, quota, setQuota, maxQuota, height, width }: {
    productId: string;
    initQuota: number;
    quota: number;
    setQuota: (quota: number) => void;
    maxQuota?: number;
    height?: number;
    width?: number;
  },
) => {
  const classes = useStyles();
  const handleSeatChange = (delta: number) => {
    const newSeats = maxQuota
      ? Math.max(initQuota, Math.min(maxQuota, quota + delta)) : quota + delta;
    setQuota(newSeats);
  };

  const handleSeatInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputSeats = parseInt(event.target.value, 10);
    if (Number.isNaN(inputSeats)) {
      setQuota(initQuota);
      return;
    }
    const newSeats = maxQuota
      ? Math.max(initQuota, Math.min(maxQuota, inputSeats))
      : Math.max(initQuota, inputSeats);
    setQuota(newSeats);
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{ border: '1px solid #e6e4ef', borderRadius: '10px', overflow: 'hidden' }}
    >
      <IconButton
        size="small"
        onClick={() => handleSeatChange(-1)}
        disabled={quota <= initQuota}
        sx={{
          borderRadius: 0,
          borderRight: '1px solid #e6e4ef',
          backgroundColor: '#f7f7fb',
          color: '#494763',
          width: width ?? 53,
          height: height ?? 53,
          '&:hover': { backgroundColor: '#f1f0f7' },
          '&:disabled': { backgroundColor: '#f7f7fb', color: '#b3b1c4' },
        }}
      >
        <Typography fontWeight={400} fontSize={16} color="inherit">-</Typography>
      </IconButton>
      <TextField
        value={quota}
        id={`${productId}-quota-input`}
        variant="outlined"
        sx={{
          '& fieldset': { border: 'none' },
          '&.MuiTextField-root': {
            height: height ?? '100%',
            width: (width ?? 50) + 10,
          },
        }}
        InputProps={{
          classes: {
            root: classes.quotaTextField,
            input: classes.quotaInputTextField,
          },
          inputProps: {
            inputMode: 'numeric',
            style: {
              width: width ?? 53,
              height: height ?? '100%',
              textAlign: 'center',
            },
          },
        }}
        onChange={handleSeatInputChange}
      />
      <IconButton
        size="small"
        onClick={() => handleSeatChange(1)}
        disabled={maxQuota ? quota >= maxQuota : false}
        sx={{
          borderRadius: 0,
          borderLeft: '1px solid #e6e4ef',
          backgroundColor: '#f7f7fb',
          color: '#494763',
          width: width ?? 53,
          height: height ?? 53,
          '&:hover': { backgroundColor: '#f1f0f7' },
          '&:disabled': { backgroundColor: '#f7f7fb', color: '#b3b1c4' },
        }}
      >
        <Typography fontWeight={400} fontSize={16} color="inherit">+</Typography>
      </IconButton>
    </Box>
  );
};
